export default {
  getSubscriptionInfo: state => state.subscriptionInfo,
  getUnsubscribeInfo: state => state.unsubscribeInfo,
  getCreateSubscription: state => state.createSubscription,
  getServiceCatalogs: state => state.serviceCatalogs,
  getErrors: state => {
    return state.errors;
  }
};
